export default {
  savedUserAfterRegister: null,
  dmsData: {},
};
